import { FeedbackSource } from "integrations/klassy/feedback-api-v2-schema";

import { Contact } from "app/account/types/models";
import { Project } from "app/projects/types/models";
import { UserStory } from "app/user-stories/types/responseTypes";

// Response Types
export type AppStoreType = "ios" | "google_play";
export type ReviewSentiment = "positive" | "negative" | "neutral";

export type Review = {
  date: string;
  author: string;
  stars: number;
  title: string;
  body: string;
  contact?: Contact;
  translatedBody?: string;
  timestamp: string;
  source?: FeedbackSource;
  id: string;
  country?: string;
  deals?: string;
  surveyResponseId?: number;
};

export type AppSearchResult = {
  id: string;
  storeType: AppStoreType;
  name: string;
  icon: string;
};

export type SummaryTermLite = {
  id: string;
  type: string;
  rank: number;
  term: string; // text
  //numberOfThreads: number
  threads?: { extra: Record<string, unknown> }[];
  mentions: number;
  reviewsCount: number;
  updatedTerm: string;
  //updatedText: string
  deletedAt: Date;
  sortOrder: number;
  projects?: Omit<Project, "sort" | "description">[];
  userStories: Array<UserStory>;
};

export type SummaryTerm = {
  id: string;
  term: string;
  dateStart: Date;
  dateEnd: Date;
  mentions: number;
  reviews: Array<Review>;
};

export type AppSummaryData = AppSearchResult & {
  ratings: {
    averageStars: number;
    total: number;
  };

  reviews: {
    sentimentSummary: {
      score: number | null;
      total: number;
    };
    sentimentTimeline: Array<{
      date: string;
      positive: number;
      negative: number;
      neutral: number;
    }>;
    recent: Array<
      Review & {
        sentiment: ReviewSentiment | null;
      }
    >;
    complaints: Array<SummaryTermLite>;
    requests: Array<SummaryTermLite>;
    loved: Array<SummaryTermLite>;
    competitors: Array<SummaryTermLite>;
    summary: string;
    numberOfThreads: number;
    numberOfAnalysedReviews: number;
  };
};

export type AppSummaryDataResponse = {
  data: Array<AppSummaryData>;
};

export type AppsResponse = {
  data: Array<{
    id: string;
    name: string;
  }>;
};

export type AppDownloadOpts = { download1Year?: boolean };

export type FeedbackAnalysisItemLite = {
  id: string;
  type: FeedbackAnalysisItemType;
  rank: number;
  text: string;
  numberOfThreads: number;
  threads: { extra: Record<string, unknown> }[];
  mentions: number;
  reviewsCount: number;
  updatedText: string;
  deletedAt: Date;
  sortOrder: number;
  userStories: Array<UserStory>;
  projects: Omit<Project, "description" | "sort">[];
};

export enum FeedbackAnalysisItemType {
  complaint = "complaint",
  request = "request",
  lovedFeature = "lovedFeature",
  competitor = "competitor",
  bug = "bug",
  takeaway = "takeaway",
  mentionedFeature = "mentionedFeature",
  painPoint = "painPoint",
  summary = "summary",
  surveyTextAnswerAnalysis = "surveyTextAnswerAnalysis",
  deepDiveComplaint = "deepDiveComplaint",
  deepDiveRequest = "deepDiveRequest",
  deepDiveLovedFeature = "deepDiveLovedFeature",
  deepDiveCompetitor = "deepDiveCompetitor",
  deepDiveBug = "deepDiveBug",
  deepDivePainPoint = "deepDivePainPoint",
  deepDiveTakeaway = "deepDiveTakeaway",
  deepDiveMentionedFeature = "deepDiveMentionedFeature",
}

export type GetCommentsAnchoredToItemRequest = {
  orgSlug: string;
  anchorCommentId: string;
  page?: number;
};
